import * as React from 'react';
import { Col, FormGroup, Input, Label } from 'reactstrap';
// tslint:disable-next-line:no-submodule-imports
import { InputProps, InputType } from 'reactstrap/lib/Input';

interface Props extends InputProps {
    row?: boolean;
    notitle?: boolean;
    fullName?: string;
    checkboxProp?: boolean;
}
export default class FormInput extends React.Component<Props> {
    public render() {
        const check = this.props.type === 'checkbox' || this.props.type === 'radio';
        if (!check) {
            return (
                <FormGroup row={this.props.row}>
                    {this.props.notitle !== true ? (
                        <Label for={this.props.name} sm={this.props.row ? 2 : undefined}>
                            {this.props.fullName}
                        </Label>
                    ) : null}
                    {this.props.row ? (
                        <Col sm={10}>
                            <Input
                                id={this.props.id}
                                className={this.props.className}
                                onChange={this.props.onChange}
                                onKeyPress={this.props.onKeyPress}
                                value={!this.props.readOnly ? this.props.value || '' : undefined}
                                defaultValue={this.props.defaultValue}
                                disabled={this.props.disabled}
                                name={this.props.name}
                                type={this.props.type}
                                placeholder={this.props.placeholder || this.props.fullName}
                                style={this.props.style}
                                min={this.props.min}
                                max={this.props.max}
                                step={this.props.step}
                                readOnly={this.props.readOnly}
                            >
                                {this.props.children}
                            </Input>
                        </Col>
                    ) : (
                            <Input
                                id={this.props.id}
                                className={this.props.className}
                                onChange={this.props.onChange}
                                onKeyPress={this.props.onKeyPress}
                                value={this.props.value || ''}
                                defaultValue={this.props.defaultValue}
                                disabled={this.props.disabled}
                                name={this.props.name}
                                type={this.props.type}
                                placeholder={this.props.placeholder || this.props.fullName}
                                style={this.props.style}
                                readOnly={this.props.readOnly}
                            >
                                {this.props.children}
                            </Input>
                        )}
                </FormGroup>
            );
        } else if (this.props.checkboxProp) {
            return (
                <FormGroup>
                    <Label check={check} style={{ marginRight: "5px"}}>
                        {this.props.fullName}
                    </Label>
                        <Input  
                            id={this.props.id}
                            className={this.props.className}
                            onChange={this.props.onChange}
                            // tslint:disable-next-line:no-any
                            checked={!this.props.readOnly ? this.props.checked || '' as any : undefined}
                            defaultChecked={this.props.defaultChecked}
                            disabled={this.props.disabled}
                            name={this.props.name}
                            type={this.props.type}
                            placeholder={this.props.placeholder || this.props.fullName}
                            style={this.props.style ?? { marginLeft: "5px", marginTop: "0.35rem"}}
                        />
                </FormGroup>
            );
        } else {
            return (
                <FormGroup check={check}>
                     <Label check={check}>
                        <Input  
                            id={this.props.id}
                            className={this.props.className}
                            onChange={this.props.onChange}
                            // tslint:disable-next-line:no-any
                            checked={!this.props.readOnly ? this.props.checked || '' as any : undefined}
                            defaultChecked={this.props.defaultChecked}
                            disabled={this.props.disabled}
                            name={this.props.name}
                            type={this.props.type}
                            placeholder={this.props.placeholder || this.props.fullName}
                            style={this.props.style}
                        />
                        {this.props.fullName}
                    </Label>
                </FormGroup>
            );
        }
    }
}
